function injectStyle (ssrContext) {
  require("!!../../../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-61d2fc6d\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CalendarIcon.vue")
}
var Component = require("!../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CalendarIcon.vue"),
  /* template */
  require("!!../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-61d2fc6d\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CalendarIcon.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61d2fc6d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/remote-edu/calendar/components/selector/components/icons/CalendarIcon.vue
// module id = 24f673f33740267a6a57
// module chunks = 7